import { Col, Divider, Row } from 'antd';
import React from 'react';
import { Company } from '../../../models/company-interface';
import { TimeZone } from '../../../models/time-zone-interface';

interface TimeZoneDisplayProps {
  companyDetails: Company | undefined;
  timeZones: TimeZone[] | undefined;
}

export default function TimeZoneDisplay({
  companyDetails,
  timeZones,
}: TimeZoneDisplayProps) {
  if (!companyDetails || !timeZones) return null;

  return (
    <>
      <Row align='middle'>
        <Col span={6}>Time Zone</Col>
        <Col span={18} style={{ textAlign: 'right' }}>
          {timeZones?.find((z) => z.id === companyDetails.timeZoneId)?.name ??
            'n/a'}
        </Col>
      </Row>
      <Divider style={{ marginTop: 16, marginBottom: 16 }} />
    </>
  );
}
